
import { ApiProperty } from '@nestjs/swagger'
import { TeachingDto } from '@sphere/school/domain'

export class CheckStudentInTeachingsResponseDto {
  @ApiProperty({
    description: 'The teaching where the user is a student, if found',
    required: false,
    type: () => TeachingDto,
  })
  teaching?: TeachingDto | null
}
